/**
 * Конфигурация бренда Headman
 * 
 * Этот файл содержит все параметры брендинга, которые можно легко изменить
 * для адаптации под другого клиента (мульти-бренд архитектура).
 */

export interface BrandConfig {
  // Основная информация
  name: string;
  tagline: string;
  description: string;
  
  // Логотипы
  logos: {
    horizontal: string;  // Широкий логотип для шапки
    square: string;      // Квадратный для иконок
  };
  
  // Цветовая палитра
  colors: {
    // Основные цвета
    primary: string;        // Основной акцентный цвет
    primarySoft: string;    // Мягкий вариант основного
    secondary: string;      // Вторичный акцент
    
    // Фоны
    bgDark: string;         // Тёмный фон
    bgElevated: string;     // Приподнятый фон (карточки)
    bgInput: string;        // Фон для инпутов
    
    // Текст
    textPrimary: string;    // Основной текст
    textSecondary: string;  // Вторичный текст
    textMuted: string;      // Приглушённый текст
    
    // Границы и эффекты
    borderSubtle: string;   // Тонкие границы
    borderHover: string;    // Границы при наведении
    
    // Специальные
    success: string;
    error: string;
    warning: string;
  };
  
  // Шрифты
  fonts: {
    heading: string;
    body: string;
  };
  
  // Контакты и ссылки
  contacts?: {
    phone?: string;
    address?: string;
    instagram?: string;
    telegram?: string;
    website?: string;
  };
}

// ============================================
// HEADMAN BARBERSHOP - Конфигурация бренда
// ============================================

export const BRAND: BrandConfig = {
  name: 'Headman Barbershop',
  tagline: 'Современные мужские стрижки',
  description: 'AI-примерка причёсок, подбор стиля и запись к мастерам Headman Barbershop',
  
  logos: {
    horizontal: '/assets/headman/logo_headman_5.png',
    square: '',
  },
  
  colors: {
    // Чёрно-белая тема с золотым акцентом
    primary: '#d4af37',           // Тёплое золото
    primarySoft: '#b8962f',       // Приглушённое золото
    secondary: '#8b7355',         // Бронзовый оттенок
    
    // Тёмные фоны (почти чёрные)
    bgDark: '#0a0a0a',            // Основной фон
    bgElevated: '#141414',        // Карточки
    bgInput: '#1a1a1a',           // Инпуты
    
    // Текст (белый/серый)
    textPrimary: '#ffffff',       // Белый
    textSecondary: '#a0a0a0',     // Серый
    textMuted: '#666666',         // Приглушённый
    
    // Границы
    borderSubtle: 'rgba(255, 255, 255, 0.08)',
    borderHover: 'rgba(255, 255, 255, 0.15)',
    
    // Статусы
    success: '#22c55e',
    error: '#ef4444',
    warning: '#f59e0b',
  },
  
  fonts: {
    heading: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
    body: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
  },
  
  contacts: {
    // Заполнить реальными данными клиента
    instagram: '@headmanbarber',
    telegram: '@headmanbarber',
  },
};

// Экспорт отдельных частей для удобства
export const { colors, logos, fonts, name: brandName } = BRAND;

// CSS-переменные для использования в стилях
export const cssVariables = `
  --brand-primary: ${BRAND.colors.primary};
  --brand-primary-soft: ${BRAND.colors.primarySoft};
  --brand-secondary: ${BRAND.colors.secondary};
  --brand-bg: ${BRAND.colors.bgDark};
  --brand-bg-elevated: ${BRAND.colors.bgElevated};
  --brand-bg-input: ${BRAND.colors.bgInput};
  --brand-text: ${BRAND.colors.textPrimary};
  --brand-text-secondary: ${BRAND.colors.textSecondary};
  --brand-text-muted: ${BRAND.colors.textMuted};
  --brand-border: ${BRAND.colors.borderSubtle};
  --brand-border-hover: ${BRAND.colors.borderHover};
`;


